export default "__VITE_ASSET__Cvhpztnp__"